


















import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VFields } from '@/models/v-fields';
import { Base } from '@/components/common/base';
import { storeService } from '@/shared';
import { Utils } from '@/helper/utils';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
})
export default class SaveStoreIPPage extends Base {
  public form: any = {};
  public refundPresetFields: Array<VFields<any>> = [];
  public refundPresetModel = {
    id: '',
    name: '',
    accountNumber: '',
    // controlNumber: '',
    isEnabled: true,
    identifiers: []
  };
  public storeId: number = 0;
  public requestProgress: boolean = false;

  public callMethod(methodName): void {
    if (methodName === 'backToStoreEdit') {
      this.$router.push({
        name: 'admin.stores.edit',
        params: {
          id: this.storeId.toString(),
          tab: 'RefundPreset'
        },
      })
        .catch((ex) => {
          console.log(ex);
        });
    }
    if (methodName === 'saveRefundPreset') {

      if (!this.form.$valid) {
        this.showAlert(false, 'Form is Invalid!');
        this.resetMethodName(methodName);
        return;
      }
      this.saveRefundPreset();
    }
    this.resetMethodName(methodName);
  }
  public resetMethodName(methodName): void {
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }
  public updateToolBar(): void {
    const buttons: any = [];
    if (this.storeId) {
      buttons.push({
        id: '0',
        type: 'button',
        title: this.$parent.$t('stores.btnBackToStoreTitle'),
        disabled: false,
        visible: true,
        class: 'btn',
        label: this.$parent.$t('stores.btnBack'),
        click: 'backToStoreEdit',
        icon: 'fas fa-arrow-left',
      });
    }
    this.$emit('updateToolBar', buttons);
  }

  public mounted() {
    this.storeId = Number(this.$route.params.storeId);
    this.setRefundPresetFields();
    // Toolbar
    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });

    if (this.$route.params.refundPresetId) {
      this.getRefundPreset();
    }
  }

  public setRefundPresetFields(): void {
    this.refundPresetFields = [
      {
        key: 'name',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          label: 'Name',
          required: true,
          disabled: false,
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
          rules: [
            v => this.required('Name', v),
          ]
        },
      },
      {
        key: 'accountNumber',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          label: 'Account Number',
          required: true,
          disabled: false,
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
          rules: [
            v => this.required('Account Number', v),
          ]
        },
      },
      // {
      //     key: 'controlNumber',
      //     type: 'v-alynk-text-field',
      //     required: true,
      //     templateOptions: {
      //       label: 'Control Number',
      //       required: true,
      //       disabled: false,
      //       loading: false,
      //       elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
      //       rules: [
      //         v => this.required('Control Number', v),
      //       ]
      //     },
      // },
      {
        key: 'identifiers',
        type: 'v-alynk-select',
        required: true,
        templateOptions: {
          label: 'Select Sections',
          multiple: true,
          required: true,
          items: [
            { text: 'RO', value: 'RO' },
            { text: 'PART SALES', value: 'PART SALES' },
            { text: 'AR', value: 'AR' },
            { text: 'ADHOC', value: 'ADHOC' },
            { text: 'DEPOSIT LOG', value: 'DEPOSIT LOG' },
            { text: 'DEAL PAYMENT REPORT', value: 'DEAL PAYMENT REPORT' }
          ],
          disabled: false,
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
          rules: [
            v => this.requiredForArray('Select Sections', v)
          ],
        },
      },
      {
        key: 'isEnabled',
        required: false,
        type: 'v-alynk-switch',
        templateOptions: {
          disabled: false,
          label: 'Enable Refund Preset',
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 float-left',
        },
      },
    ];
  }

  public async getRefundPreset(): Promise<void> {
    try {
      this.formlyShowSkeleton(this.refundPresetFields);
      const response = await storeService.getRefundPrestByStore(this.storeId);
      const selectedRefundPreset = response.storeJson.refundPresets.find(
        (m) => m.id == this.$route.params.refundPresetId
      );
      this.refundPresetModel = selectedRefundPreset;
    } finally {
      this.formlyHideSkeleton(this.refundPresetFields);
    }
  }

  public validateRefundPreset(): Vue & { validate: () => boolean } {
    return this.$refs.refundPresetForm as Vue & { validate: () => boolean };
  }

  public async saveRefundPreset(): Promise<void> {
    if (this.validateRefundPreset().validate()) {
      try {
        this.requestProgress = true;
        this.$emit('update:progress', this.requestProgress);
        if (this.refundPresetModel.id == '') {
          await storeService.saveRefundPreset(this.storeId, this.refundPresetModel);
          this.showAlert(true, 'Refund Preset Added successfully');
          this.$router.push({
            name: 'admin.stores.edit',
            params: {
              tab: 'RefundPreset'
            }
          })
            .catch((ex) => {
              console.log(ex);
            });
        }
        else {
          await storeService.updateRefundPreset(this.storeId, this.refundPresetModel);
          this.showAlert(true, 'Refund Preset Updated successfully');
          this.$router.push({
            name: 'admin.stores.edit',
            params: {
              storeId: this.storeId.toString(),
              tab: 'RefundPreset'
            },
          })
            .catch((ex) => {
              console.log(ex);
            });
        }
      } finally {
        this.requestProgress = false;
        this.$emit('update:progress', this.requestProgress);
      }
    }
  }
}
